import { StencilCDNImage } from '@/components/Common/StencilImage'

import useImageFailedHandle from '@/hooks/useImageFailedHandle'

function ImageFallback({
  fallback = '',
  height,
  width,
}: {
  fallback?: string
  height?: number
  width?: number
}) {
  return (
    <div
      className="mb-3 flex h-12 w-12 items-center justify-center rounded-[50%] bg-brand-tertiary-grey"
      style={{ height: height ?? 42, width: width ?? 42 }}
    >
      {fallback && (
        <span className="text-center text-13px font-semibold text-brand-black">
          {fallback}
        </span>
      )}
    </div>
  )
}

export default function StockImage({
  src,
  alt,
  fallback,
  priority,
  height,
  width,
}: {
  src: string
  alt: string
  fallback?: string
  priority?: boolean | undefined
  height?: number
  width?: number
}) {
  const [imageErrored, handleImageError] = useImageFailedHandle()
  const [placeHolderImageErrored, handlePlaceholderImageErrored] =
    useImageFailedHandle()

  if (!src) {
    return (
      <div className="mb-1">
        <ImageFallback fallback={fallback} height={height} width={width} />
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center text-center md:block md:text-left">
      {src && !imageErrored && (
        <StencilCDNImage
          className="rounded-full"
          height={height ?? 42}
          width={width ?? 42}
          src={src}
          alt={alt}
          onError={handleImageError}
          objectFit="contain"
          priority={priority}
          style={{ height: height ?? 42, width: width ?? 42 }}
        />
      )}

      {imageErrored && !placeHolderImageErrored && (
        <StencilCDNImage
          className="mb-1"
          height={height ?? 42}
          width={width ?? 42}
          src="https://indcdn.indmoney.com/public/images/defaultStock.png"
          alt="placeholder stock icon"
          onError={handlePlaceholderImageErrored}
          objectFit="contain"
          priority={priority}
        />
      )}

      {placeHolderImageErrored && imageErrored && <ImageFallback />}
    </div>
  )
}
